module.exports = __webpack_public_path__ + "files/c1ad1b01278dae49323f4a99c88d47ba.png";